import Vue from 'vue'
import VueRouter from 'vue-router'
//import Home from '../views/Home.vue'
import modules from './modules/index'
import global from '@/public/global.js'
import axios from '@/config/http'
import store from '@/store'
import tools from "@/public/tools.js"
Vue.use(VueRouter)
const quoteRouterList = {
	'/pcb-quote':'pcb_quote',
	'/flex-pcb-quote':'fpc_quote',
	'/rigid-flex-pcb-quote':'rfpc_quote',
	'/quote-by-sales':'quote_sales',
	'/pcb-assembly-quote':'smt_quote',
	'/pcb-stencil-quote':'smd_quote',
	'/quote-layout':'layout',
	'/bom-service':'bom',
	'/pcb-quote-advance':'pcb_quote_advance',
}
let redirect,hmmeComponent,query = null;
for(let k in quoteRouterList){
	if(window.STAY.indexOf(k)>=0){
		redirect = k;
		hmmeComponent = quoteRouterList[k];
		if(window.STAY.includes('?')){
			query = tools.getAllUrlParameters(window.STAY)
		}
		console.log(window.STAY, query)	
	}
}
const routes = [
	{
		path: '/',
		name: 'Home',
		redirect: redirect,
		component: () => import('@/views/quote/'+hmmeComponent+'.vue')
	}
].concat(modules);

// 路由异常处理
const originalPush = VueRouter.prototype.push
const originalReplace = VueRouter.prototype.replace
// push
VueRouter.prototype.push = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}
// replace
VueRouter.prototype.replace = function push (location, onResolve, onReject) {
  if (onResolve || onReject) return originalReplace.call(this, location, onResolve, onReject)
  return originalReplace.call(this, location).catch(err => err)
}

const router = new VueRouter({
	mode: 'hash',
	base: process.env.BASE_URL,
	routes
})

router.beforeEach(async (to,from,next)=>{
	// const langData = tools.getSlocal('LANG')
	// const hasLang = Object.keys(langData).length === 0 && langData.constructor === Object;
	// console.log('router.beforeEach',to,from,next,to.redirectedFrom == '/', query)
	if (to.redirectedFrom && to.redirectedFrom == '/' && query) {
		console.log('replace 跳转')
		router.replace(window.STAY);
		return 
	}
	store().commit('setIsLoadingPage', true)
	// 获取语言包
	await store().dispatch('getLanguge', { langKey: 'LANG' })
	// await store().dispatch('getLanguge', { langKey: 'MLANG', params: { route: 'member'} })
	
	//终止请求接口
	if(global.requests && global.requests.length){
		global.requests.forEach((bc)=>{
			bc()
		});
		global.requests = [];
		//并设置请求遮罩为隐藏				
	}
	// 原有软板及刚柔板界面url跳转至PCB计价界面
	if(to.path === '/flex-pcb-quote' || to.path === '/rigid-flex-pcb-quote') {
		window.location.href = "/pcb-quote";
	}
	// 获取登录状态
	axios.jsonp(window.LOGINURL + "/auth/getCrossToken").then((res)=>{ 
		if(res.retCode == 200 && res.result){
			//已登录  设置登录信息  
			store().commit("setLoginInfo",res.result);              
			// app.store.commit("app/setLoginInfo",res.result);
			// app.store.commit('app/setToken',res.result.token);
			// app.store.commit('app/setContent',res.result.content);                                
		}else{
			//登录失败 清除登录信息
			store().commit("clearUserInfo");                        
		}
	})

	next();
})

// 关闭加载状态
router.afterEach(() => {
  // 如果你使用 Vuex
  store().commit('setIsLoadingPage', false)
})
export default router;
